import Vue from 'vue'
import Router from 'vue-router'
import { handlePrivateRoutes, isLoggedIn } from '../auth'

// Routes
import commonRoutes from './common'
import buyerRoutes from './buyer'
import sellerRoutes from './seller'

const { $isBuyer } = Vue.prototype
const targetRoutes = $isBuyer ? buyerRoutes : sellerRoutes

export const routes = [...commonRoutes, ...targetRoutes]

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior: () => ({ x: 0, y: 0 })
})

// TODO: Handle private routes
router.beforeEach((to, from, next) => {
  const guestOnly = to.matched.some(record => record.meta.guestOnly)
  if (guestOnly) return isLoggedIn() ? next('/') : next()

  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  if (requiresAuth) return handlePrivateRoutes(to, from, next)

  return next()
})

export default router
